jQuery(document).ready(function($) {

    // Add loading class to buttons on click
    $('.site-header__cart .button, .woocommerce-mini-cart__buttons .button')
        .each(function() {

            $(this).on('click', function() {

                $(this).addClass('loading');

            });

        });

    $(document).on('click', '.sku, .sku_wrapper, .product-sku', function() {

        const sku = $(this).text()
            .replace('Artikelnr: ', '')
            .replace('Art. nr: ', '');

        $('<textarea/>').appendTo('body').val(sku).select().each(function() {
            document.execCommand('copy');
        }).remove();

    });

    $(document).on('click', '.toggle-term-description', function() {

        var windowWidth = $(window).outerWidth();

        if ($(this).parent().hasClass('active')) {
            $(this).parent().removeClass('active');
            $(this).text('Läs mer');
            if (windowWidth > 1023) {
                $(this)
                    .parent()
                    .next()
                    .find('.term-header-content')
                    .fadeOut(100);
            } else {
                $(this)
                    .parent()
                    .next()
                    .find('.term-header-content')
                    .slideUp(300);
            }
        } else {
            $(this).parent().addClass('active');
            $(this).text('Läs mindre');
            if (windowWidth > 1023) {
                $(this)
                    .parent()
                    .next()
                    .find('.term-header-content')
                    .fadeIn(100);
            } else {
                $(this)
                    .parent()
                    .next()
                    .find('.term-header-content')
                    .slideDown(300);
            }
        }

    });

    $(document).on('click', '#testfreaks-badge', function(e) {
        e.preventDefault();
        if (!$('.tab-toggle.reviews').hasClass('active')) {
            $('.tab-toggle.reviews').trigger('click');
        }
    });

});
